import champsService from '../services/champsService'
import { sortBy } from 'lodash'

const state = {
  internalChamps: {
    season: null,
    seasons: null,
    items: null,
    loaded: false
  },
  externalChamps: {
    season: null,
    seasons: null,
    items: null,
    loaded: false
  }
}

const mutations = {
  saveSeasons (state, { items, type }) {
    state[type].seasons = sortBy(items).reverse()
  },
  saveChamps (state, { items, type }) {
    state[type].items = state[type].items || []
    state[type].items.push(...items)
  },
  setChampsLoadedStatus (state, { type, status }) {
    state[type + 'Champs'].loaded = status
  },
  resetChamps (state) {
    state.internalChamps = {
      season: null,
      seasons: null,
      items: null,
      loaded: false
    }

    state.externalChamps = {
      season: null,
      seasons: null,
      items: null,
      loaded: false
    }
  }
}

const actions = {
  triggerChampsUpdate ({ state, commit }, countChanged) {
    state.seasonsId = null
    commit('resetChamps')
    if (countChanged) {
      commit('club/resetClubStarts', null, { root: true })
    }
  },
  getClubSeasons ({ state, commit }, { clubId }) {
    if (state.seasonsId === clubId &&
      state.internalChamps.seasons &&
      state.externalChamps.seasons
    ) {
      return
    }

    state.internalChamps.seasons = null
    state.externalChamps.seasons = null
    state.seasonsId = clubId

    champsService.getSeasons({
      clubId,
      championshipsType: 1
    })
      .then(response => {
        commit('saveSeasons', {
          items: response.data,
          type: 'internalChamps'
        })
      })
    champsService.getSeasons({
      clubId,
      championshipsType: 2
    })
      .then(response => {
        commit('saveSeasons', {
          items: response.data,
          type: 'externalChamps'
        })
      })
  },
  getChamps ({ commit, rootState }, { clubId, championshipsType, onlyOneId, seasonYear, searchString, onlyActive, showDrafts, skip, take }) {
    const type = championshipsType === 1 ? 'internalChamps' : 'externalChamps'
    state[type].season = seasonYear

    return champsService.getChamps({
      clubId,
      championshipsType,
      onlyOneId,
      seasonYear,
      userId: rootState.user.user.id,
      searchString,
      onlyActive,
      showDrafts,
      orderByStatus: false,
      skip,
      take
    })
      .then(response => {
        commit('saveChamps', {
          items: response.data.Championships,
          type: type
        })
      })
  }
}

export const champs = {
  namespaced: true,
  state,
  mutations,
  actions
}
